import React from 'react';
import styles from './styles.module.scss';
function Overlay({ display: active, children }) {
    return (React.createElement("div", { className: styles.root },
        React.createElement("div", { className: styles.overlay, style: { visibility: active ? 'visible' : 'hidden' } }),
        children));
}
export default Overlay;
